import { useState, useEffect } from 'react'
import { Button } from '../ui/button'
import { Input } from '../ui/input'
import { ScrollArea } from '../ui/scroll-area'

interface Session {
  id: string
  createdAt: string
}

export function SessionManager() {
  const [sessions, setSessions] = useState<Session[]>([])
  const [newSessionName, setNewSessionName] = useState('')
  const currentSessionId = localStorage.getItem('session_id')

  useEffect(() => {
    loadSessions()
  }, [])

  const loadSessions = () => {
    const savedSessions = localStorage.getItem('saved_sessions')
    if (savedSessions) {
      setSessions(JSON.parse(savedSessions))
    }
  }

  const createSession = () => {
    const newSession = {
      id: crypto.randomUUID(),
      createdAt: new Date().toISOString()
    }
    
    const updatedSessions = [...sessions, newSession]
    localStorage.setItem('saved_sessions', JSON.stringify(updatedSessions))
    setSessions(updatedSessions)
    setNewSessionName('')
  }

  const loadSession = (sessionId: string) => {
    localStorage.setItem('session_id', sessionId)
    window.location.reload()
  }

  const deleteSession = (sessionId: string) => {
    const updatedSessions = sessions.filter(s => s.id !== sessionId)
    localStorage.setItem('saved_sessions', JSON.stringify(updatedSessions))
    setSessions(updatedSessions)
  }

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Sessions</h3>
      
      <div className="flex gap-2">
        <Input
          placeholder="New session name"
          value={newSessionName}
          onChange={(e) => setNewSessionName(e.target.value)}
        />
        <Button onClick={createSession}>Create</Button>
      </div>

      <ScrollArea className="h-[200px] pr-4">
        <div className="space-y-2">
          {sessions.map((session) => (
            <div key={session.id} className="flex items-center justify-between p-2 border rounded">
              <div className="flex flex-col flex-1 min-w-0">
                <span className="text-sm font-medium truncate">
                  {session.id === currentSessionId ? '(Current) ' : ''}
                  {new Date(session.createdAt).toLocaleString()}
                </span>
                <span className="text-xs text-gray-500 truncate">{session.id}</span>
              </div>
              <div className="flex gap-2 flex-shrink-0">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => loadSession(session.id)}
                  disabled={session.id === currentSessionId}
                >
                  Load
                </Button>
                <Button
                  variant="destructive"
                  size="sm"
                  onClick={() => deleteSession(session.id)}
                  disabled={session.id === currentSessionId}
                >
                  Delete
                </Button>
              </div>
            </div>
          ))}
        </div>
      </ScrollArea>
    </div>
  )
}
